import styled, { css } from 'styled-components';
import { borderRadius, colorPalette, getSpacing, typography } from 'stylesheet';

interface ButtonLinkAttrs {
  href?: string;
  to?: string;
}

const Button = styled.button<ButtonLinkAttrs>`
  padding: ${getSpacing(2)} ${getSpacing(4)};
  ${typography.bold}
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  ${props =>
    props.disabled &&
    css`
      pointer-events: none;
    `}

  border: none;
  border-radius: ${borderRadius.medium};

  text-decoration: none;

  color: ${colorPalette.white};
  background-color: ${props => (props.disabled ? colorPalette.blueLight : colorPalette.blueDark)};
  transition: background-color 0.3s ease-in-out;

  &:hover {
    background-color: ${props => (props.disabled ? colorPalette.blue : colorPalette.blueDarker)};
  }
`;

export default Button;
